import { jwtDecode } from 'jwt-decode';

export function isTokenExpired(token: string | null): boolean {
  if (!token) return true;
  const { exp } = jwtDecode<{ exp: number }>(token);
  return exp * 1000 < Date.now();
}
